import { useLocalization } from '@lib/localization';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

interface Props {
  kind: 'field' | 'group';
  name: string;
  /** Fields of the group, or fields asked only because of this field. */
  dependents: number;
  /** Other rules that read this field and will lose that condition. */
  readers: number;
  onCancel: () => void;
  /** `false` keeps the follow-ups, as always-asked fields. */
  onConfirm: (withDependents: boolean) => void;
}

/** Confirms a deletion, and asks what happens to follow-ups when there are any. */
const DeleteDialog: React.FC<Props> = ({ kind, name, dependents, readers, onCancel, onConfirm }) => {
  const { t } = useLocalization();

  const followUps = kind === 'field' && dependents > 0;

  return (
    <Dialog open onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>{kind === 'group' ? t('Customization_DeleteGroup') : t('Customization_Designer_DeleteField')}</DialogTitle>
      <DialogContent>
        <Typography>{kind === 'group' ? t('Customization_ConfirmDeleteGroup', [name]) : t('Customization_ConfirmDeleteField', [name])}</Typography>
        {followUps && <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>{t('Customization_Designer_DeleteFollowUps', { count: dependents })}</Typography>}
        {readers > 0 && <Typography variant="body2" color="warning.main" sx={{ mt: 1.5 }}>{t('Customization_Designer_DeleteReaders', { count: readers })}</Typography>}
      </DialogContent>
      <DialogActions>
        <Button color="inherit" sx={{ textTransform: 'none' }} onClick={onCancel}>{t('Common_Cancel')}</Button>
        {followUps && <Button sx={{ textTransform: 'none' }} onClick={() => onConfirm(false)}>{t('Customization_Designer_KeepFollowUps')}</Button>}
        <Button color="error" variant="contained" disableElevation sx={{ textTransform: 'none' }} onClick={() => onConfirm(true)}>
          {followUps ? t('Customization_Designer_DeleteWithFollowUps') : t('Common_Delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
